import { FC, memo } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

type TButtonVariant = 'light-blue' | 'green' | 'secondary-light-blue' | 'secondary-green' | 'blue' | 'red' | 'secondary-blue';

type TButtonProps = {
  onClick?: () => void;
  variant?: TButtonVariant;
  icon?: string;
};

const Button: FC<TButtonProps> = memo(({ onClick, variant = 'blue', icon }) => {
  const buttonClass = classNames(styles.button, 'button', {
    [styles.blue]: variant === 'blue',
    [styles.red]: variant === 'red',
    [styles.secondaryBlue]: variant === 'secondary-blue',
    [styles.lightBlue]: variant === 'light-blue',
    [styles.green]: variant === 'green',
    [styles.secondaryLightBlue]: variant === 'secondary-light-blue',
    [styles.secondaryGreen]: variant === 'secondary-green',
  });

  return (
    <button className={buttonClass} onClick={onClick}>
      <div className={styles.background} />
      {icon && <span className={icon} />}
    </button>
  );
});

export default Button;
